<script setup>
import {
  HoverCardContent,
  HoverCardPortal,
  useForwardPropsEmits,
} from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { reactiveOmit } from "@vueuse/core";

defineOptions({ inheritAttrs: false });

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  side: { type: String, default: "bottom" },
  sideOffset: { type: Number, default: 8 },
  align: { type: String, default: "start" },
  alignOffset: { type: Number, default: undefined },
  avoidCollisions: { type: Boolean, default: true },
  collisionPadding: { type: [Number, Object], default: 12 },
  forceMount: { type: Boolean, default: undefined },
});

const emits = defineEmits([
  "escapeKeyDown",
  "pointerDownOutside",
  "focusOutside",
  "interactOutside",
]);

const delegatedProps = reactiveOmit(props, "class");
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <HoverCardPortal>
    <HoverCardContent
      data-slot="hover-card-content"
      v-bind="{ ...$attrs, ...forwarded }"
      :class="
        cn(
          'bg-popover text-popover-foreground z-50 origin-(--reka-hover-card-content-transform-origin) rounded-[var(--radius)] border outline-none shadow-[0_8px_30px_rgba(0,0,0,0.08)] will-change-transform',
          'data-[state=open]:animate-in data-[state=closed]:animate-out',
          'data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0',
          'data-[state=open]:zoom-in-95 data-[state=closed]:zoom-out-95',
          'data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1',
          'data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1',
          'motion-reduce:animate-none motion-reduce:transition-opacity',
          props.class
        )
      "
    >
      <slot />
    </HoverCardContent>
  </HoverCardPortal>
</template>
